import {
  LoadingSkeleton,
  Modal,
} from "@twinkltech/curriculum-architect-component-library";
import { ComponentProps } from "react";

export const LoadingModal = ({
  ...props
}: { onClose: () => void } & Omit<
  ComponentProps<typeof Modal>,
  "children"
>) => {
  return (
    <Modal {...props}>
      <Modal.Header>
        <Modal.Title className="sr-only">Modal is loading</Modal.Title>
        <LoadingSkeleton
          className="mt-2"
          height="2rem"
          role="presentation"
          width="80%"
        />
      </Modal.Header>
      <Modal.Body>
        <div className="flex flex-col gap-4">
          <LoadingSkeleton className="my-4" height="1.75rem" width="30%" />
          {Array.from({ length: 5 }).map((_, index) => (
            <LoadingSkeleton key={index} height="1rem" width="90%" />
          ))}

          <div className="flex flex-col gap-4 mt-12">
            {Array.from({ length: 5 }).map((_, index) => (
              <LoadingSkeleton key={index} height="1rem" width="90%" />
            ))}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <LoadingSkeleton className="mb-2" height="2.5rem" width="25%" />
      </Modal.Footer>
    </Modal>
  );
};
